import React from 'react'
import { Loader2, Search, X } from 'lucide-react'
import { Input } from '@/components/ui/Input'

interface VehicleSearchInputProps {
  value: string
  onChange: (value: string) => void
  onFocus?: () => void
  placeholder: string
  disabled?: boolean
  isLoading?: boolean
  showClear?: boolean
  onClear?: () => void
}

export const VehicleSearchInput: React.FC<VehicleSearchInputProps> = ({
  value,
  onChange,
  onFocus,
  placeholder,
  disabled = false,
  isLoading = false,
  showClear = false,
  onClear,
}) => {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 transform text-muted-foreground pointer-events-none" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        placeholder={placeholder}
        disabled={disabled}
        className="pl-10 pr-10"
      />
      {isLoading ? (
        <Loader2 className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 transform animate-spin text-muted-foreground" />
      ) : (
        showClear &&
        onClear && (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 transform p-1 hover:bg-surface rounded"
          >
            <X className="h-4 w-4 text-muted-foreground" />
          </button>
        )
      )}
    </div>
  )
}

